import api from 'app/shared/utils/api';
import AddressDetails from 'app/shared/model/AddressDetails';
import AutoCompleteAddresses from 'app/shared/model/AutoCompleteAddresses';
import Constants from 'app/shared/constants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import promise from 'promise';

// service
import appLogger from 'app/shared/loggers/appLogger';

const AddressActions = {
    autocomplete(partialAddress) {
        return dispatch => dispatch(api.properties.address.autocomplete(partialAddress))
            .then((response = {}) => {
                if (response.success && response.response) {
                    const autoCompleteAddressModel = AutoCompleteAddresses(response.response);

                    dispatch({
                        type: Constants.ADDRESS_AUTO_COMPLETE,
                        payload: {
                            addressList: autoCompleteAddressModel.addresses,
                        },
                    });
                }
            });
    },
    getComps(zpid) {
        return dispatch => dispatch(api.properties.address.comps(zpid))
            .then((response) => {
                if (response.success && response.response) {
                    return response.response;
                }
                return promise.reject(response.error);
            });
    },
    getDetails(addressData) {
        return dispatch => dispatch(api.properties.address.details(addressData))
            .then((response) => {
                const { error: errorRMWModel, success, response: getDetailsResponse } = response;
                if (success && getDetailsResponse) {
                    const { status, message } = getDetailsResponse;
                    if (status && status.toLowerCase() === Constants.ADDRESS_STATUS_FAILURE.toLowerCase()) {
                        return promise.reject(message);
                    }
                    const addressDetailsModel = AddressDetails(getDetailsResponse);

                    dispatch({
                        type: DispatchConstants.ADDRESS_DETAILS,
                        payload: addressDetailsModel,
                    });

                    return addressDetailsModel;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'AddressActions.getDetails',
                });

                return promise.reject(errorRMWModel);
            });
    },
    verify(addressData) {
        return dispatch => dispatch(api.properties.address.verification({
            address: addressData.address,
            unit: addressData.unit,
        })).then((response) => {
            if (response.success && response.response) {
                return response.response;
            }
            return promise.reject(response.error);
        });
    },
    getRestrictions(addressData) {
        const {
            address,
            unit,
            listingTypeCode,
            listingAlias,
            propertyTypeCode,
        } = addressData;
        return dispatch => dispatch(
            api.properties.locations.getRestrictions({
                address,
                unit,
                listingTypeCode,
                listingAlias,
                propertyTypeCode,
            })
        )
            .then((response) => {
                const { error: errorRMWModel, success } = response;

                if (success && response.response) {
                    return response.response;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'AddressActions.getRestrictions',
                });
                return promise.reject(errorRMWModel);
            });
    },
    getPublicRestrictions(addressData) {
        const {
            address,
            unit,
            listingTypeCode,
            listingAlias,
            propertyTypeCode,
        } = addressData;
        return dispatch => dispatch(
            api.properties.locations.getPublicRestrictions({
                address,
                unit,
                listingTypeCode,
                listingAlias,
                propertyTypeCode,
            })
        )
            .then((response) => {
                const { error: errorRMWModel, success } = response;

                if (success && response.response) {
                    return response.response;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'AddressActions.getPublicRestrictions',
                });
                return promise.reject(errorRMWModel);
            });
    },
};

export default AddressActions;
